module.exports = __webpack_public_path__ + "live_player_icon-bf9e2aa0.png";